import { useEffect } from 'react';
import { PartyPopper, Frown } from 'lucide-react';
import type { OverlayFeedbackState } from '../types/quiz.types';

interface OverlayFeedbackProps extends OverlayFeedbackState {
  onClose: () => void;
}

export function OverlayFeedback({ visible, result, context, message, onClose }: OverlayFeedbackProps) {
  useEffect(() => {
    if (!visible) return;
    const id = setTimeout(() => {
      onClose();
    }, 2800);
    return () => clearTimeout(id);
  }, [visible, onClose]);

  if (!visible) return null;

  const isSuccess = result === 'success';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
      <div
        className={`relative max-w-md w-[90%] rounded-2xl border px-6 py-6 text-center shadow-xl
        ${
          isSuccess
            ? 'bg-emerald-900/40 border-emerald-400'
            : 'bg-slate-900/60 border-slate-600'
        }`}
      >
        {isSuccess ? (
          <div className="flex justify-center mb-4">
            <PartyPopper className="w-10 h-10 text-amber-300" />
          </div>
        ) : (
          <div className="flex justify-center mb-4">
            <Frown className="w-10 h-10 text-slate-300" />
          </div>
        )}

        <h2 className="text-xl font-bold text-white mb-2">
          {isSuccess ? 'Parabéns!' : 'Quase lá...'}
        </h2>
        <p className="text-slate-200 text-sm mb-4">
          {message ??
            (isSuccess
              ? 'Desafio concluído com sucesso.'
              : 'Não foi dessa vez, mas você está aprendendo com cada tentativa.')}
        </p>

        {isSuccess && (
          <div className="pointer-events-none absolute inset-0 overflow-hidden">
            <div className="animate-pulse opacity-60">
              <div className="absolute -top-4 left-8 w-2 h-2 bg-amber-300 rounded-full" />
              <div className="absolute -top-2 right-6 w-2 h-2 bg-emerald-300 rounded-full" />
              <div className="absolute top-6 left-1/4 w-2 h-2 bg-sky-300 rounded-full" />
              <div className="absolute top-10 right-1/4 w-2 h-2 bg-pink-300 rounded-full" />
            </div>
          </div>
        )}

        <button
          onClick={onClose}
          className="mt-2 inline-flex items-center justify-center px-4 py-2 rounded-xl bg-slate-800 text-slate-100 text-sm font-medium hover:bg-slate-700 transition relative z-10"
        >
          Continuar
        </button>

        {context === 'duelo' && (
          <p className="mt-2 text-xs text-slate-400 relative z-10">
            {isSuccess ? 'Modo Tudo ou Nada completo.' : 'Seu próximo checkpoint está seguro novamente.'}
          </p>
        )}
      </div>
    </div>
  );
}

